// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "rec-" + chunkId + "." + {"286":"e29c603e","302":"0cf69c7e","353":"7391c14d","525":"d405c314","638":"d8b7ebdb","641":"16b66292","814":"835c08a0","977":"28698e0c"}[chunkId] + ".js";
};